module.exports = __webpack_public_path__ + "img/FaqSpurDemo2.aab0a293.gif";